<template>
  <section class="clearfix mb-0 d-flex justify-content-between  ">

    <section class="flex-grow-1 d-flex align-items-center">
      <span class="float-md-left d-block d-md-inline-block">
        <strong class="d-none d-md-inline">COPYRIGHT</strong> © {{ new Date().getFullYear() }}
        <span class="d-sm-inline-block">, Todos los derechos reservados</span>
      </span>
    </section>

    <article class="d-none d-md-block">
      <logo url="/" class="me-5" />
    </article>

  </section>
</template>


<script setup>
import Logo from 'components/Logo.vue';
</script>